// A time of day as every page shows it: h:mm AM / PM. What is stored stays H:MM (24 h) — In:, Out:,
// App Time, and the time of a PE Order Start / End Time — so this is display only: `parseTime`
// (`shipping.ts`) reads both forms back.

/**
 * A stored time (H:MM, 24 h) as every page shows it, h:mm AM / PM: "7:30" → "7:30 AM", "14:05" →
 * "2:05 PM", "12:00" → "12:00 PM" (noon), "0:00" → "12:00 AM" (midnight); anything else as it is, ""
 * for nothing. Display only: what is stored stays H:MM.
 */
export function timeShown(v: string | null | undefined): string {
  const m = /^(\d{1,2}):(\d{2})$/.exec((v ?? "").trim());
  if (!m || Number(m[1]) > 23 || Number(m[2]) > 59) return v ?? "";
  const h = Number(m[1]);
  return `${hour12(h)}:${m[2]} ${halfOf(h)}`;
}

/** Before noon or from noon. */
export type TimeHalf = "AM" | "PM";
export const TIME_HALVES: readonly TimeHalf[] = ["AM", "PM"];
/** A 24-hour hour's half of the day: AM before 12:00, PM from 12:00. */
export const halfOf = (h24: number): TimeHalf => (h24 < 12 ? "AM" : "PM");
/** A 24-hour hour on the 12-hour clock: 0 → 12, 13 → 1. */
export const hour12 = (h24: number) => h24 % 12 || 12;
/** A 12-hour hour and its half as a 24-hour hour: 12 AM → 0, 12 PM → 12, 2 PM → 14. */
export const hour24 = (h12: number, half: TimeHalf) => (h12 % 12) + (half === "PM" ? 12 : 0);
/** A 24-hour hour and a minute as shown: "2:05 PM". */
export const timeOf = (h24: number, m: number) => timeShown(`${h24}:${String(m).padStart(2, "0")}`);

/** A moment's local time of day as shown: "2:05 PM" (the System log's When, a page's last load). */
export const clockText = (d: Date) => timeOf(d.getHours(), d.getMinutes());
